import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-card-spinner',
  templateUrl: './card-spinner.component.html',
})
export class CardSpinnerComponent {
  @Input() show: boolean;
}
